import { render } from "./IconBar.vue?vue&type=template&id=e2bc26d8&scoped=true"
import script from "./IconBar.vue?vue&type=script&lang=js"
export * from "./IconBar.vue?vue&type=script&lang=js"

import "./IconBar.vue?vue&type=style&index=0&id=e2bc26d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2bc26d8"]])

export default __exports__